module.exports = __webpack_public_path__ + "media/site_templates/www.furnituredisposal.com.au/images/splash-9b0b0b0d6bebeb7ded8835746737e308.jpg";